import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { bind, Enums, InputDropdownMultiSelectFilter, toKeyArray } from 'Mri.Web.Common';
import * as React from 'react';
import { DisplayListViewModel } from './DisplayListViewModel';

interface IIncidentOption {
    value: Mri.DisplayApi.DowntimeIncidentTypes;
    label: string;
}

export interface IDisplayEventFilterDropdownProps {
    readonly vm: DisplayListViewModel;
}

@observer
export class DisplayEventFilterDropdown extends React.Component<IDisplayEventFilterDropdownProps> {
    public constructor(props: IDisplayEventFilterDropdownProps) {
        super(props);

        for (const key of toKeyArray(Enums.DowntimeIncidentType)) {
            this.options.push({
                value: Number(key) as Mri.DisplayApi.DowntimeIncidentTypes,
                label: Enums.toString(Enums.DowntimeIncidentType, key),
            });
        }
    }

    @action
    public componentWillUnmount() {
        this.onChange(undefined);
    }

    public render() {
        const { onFilterDropdownToggle } = this.props.vm;

        return (
            <InputDropdownMultiSelectFilter
                title="Events"
                filter={this.filter}
                options={this.options}
                style={{
                    minWidth: 400,
                }}
                print={this.print}
                onToggle={onFilterDropdownToggle}
                onChange={this.onChange}
                openOnMount
            />
        );
    }

    @computed
    private get filter() {
        const { displayEventFilter } = this.props.vm;

        if (!displayEventFilter?.downtimeIncidentTypes) return;

        return displayEventFilter.downtimeIncidentTypes
            .map(t => this.options.find(o => o.value == t))
            .filter(t => !!t) as IIncidentOption[];
    }

    @bind
    @action
    private onChange(value: IIncidentOption[] | undefined) {
        if (value != undefined) {
            if (this.props.vm.displayEventFilter == undefined) {
                this.props.vm.displayEventFilter = {
                    displayEventTypes: [],
                    downtimeIncidentTypes: [],
                    displayEventStatus: [],
                    detailsSearch: '',
                };
            }

            const { displayEventFilter } = this.props.vm;

            displayEventFilter.downtimeIncidentTypes = value.map(o => o.value);
        } else {
            this.props.vm.displayEventFilter = undefined;
        }
    }

    private print(entity: IIncidentOption) {
        return entity.label;
    }

    private options: IIncidentOption[] = [];
}
